import { render } from "./DashboardViewOld.vue?vue&type=template&id=4e577d9a"
import script from "./DashboardViewOld.vue?vue&type=script&lang=js"
export * from "./DashboardViewOld.vue?vue&type=script&lang=js"

import "./DashboardViewOld.vue?vue&type=style&index=0&id=4e577d9a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__